import React, { FunctionComponent } from "react";
import styled from "styled-components";

interface IProgressBar extends IProgressBarOuter {
  barColor?: string;
  value: number;
}

interface IProgressBarOuter {
  initialBarWidth?: number;
}

const ProgressBarOuter = styled("div")`
  position: relative;
  margin-left: 18px;
  margin-right: 18px;
  background-color: #ececec;
  width: ${(props: IProgressBarOuter) =>
        props.initialBarWidth ? props.initialBarWidth : 100}%;
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  display: inline-block;
`;

const ProgressBarInner = styled("div")`
  position: absolute;
  background-color: ${(props: IProgressBar) =>
        props.barColor ? props.barColor : "#5B52F9"};
  width: ${(props: IProgressBar) => props.value}%;
  height: 6px;
`;

export const ProgressBar: FunctionComponent<IProgressBar> = (
    props: IProgressBar
) => {
    return (
        <ProgressBarOuter initialBarWidth={props.initialBarWidth}>
            <ProgressBarInner barColor={props.barColor} value={props.value} />
        </ProgressBarOuter>
    );
};
